/**
 * Metric Card Component
 * Displays a single metric with label and optional trend
 */

import React from 'react';
import { TrendUp, TrendDown } from '@phosphor-icons/react';
import { cn } from '../../lib/utils';

export const MetricCard = ({
  label,
  value,
  subValue,
  trend,
  trendValue,
  icon: Icon,
  variant = 'default',
  className,
  testId,
}) => {
  const variants = {
    default: 'bg-card',
    success: 'bg-emerald-50/50',
    warning: 'bg-amber-50/50',
    danger: 'bg-red-50/50',
  };

  const trendColors = {
    up: 'text-emerald-600',
    down: 'text-red-600',
    neutral: 'text-muted-foreground',
  };

  return (
    <div 
      data-testid={testId}
      className={cn(
        'card-premium',
        variants[variant],
        className
      )}
    >
      <div className="flex items-start justify-between mb-3">
        <span className="metric-label">{label}</span>
        {Icon && (
          <Icon size={20} className="text-muted-foreground" />
        )}
      </div>

      <div className="space-y-1">
        <p className="metric-value">{value}</p>
        
        {(subValue || trend) && (
          <div className="flex items-center gap-2">
            {subValue && (
              <span className="text-sm text-muted-foreground">{subValue}</span>
            )}
            {trend && (
              <span className={cn(
                'flex items-center gap-0.5 text-sm font-medium',
                trendColors[trend]
              )}>
                {trend === 'up' && <TrendUp size={14} weight="bold" />}
                {trend === 'down' && <TrendDown size={14} weight="bold" />}
                {trendValue}
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default MetricCard;
